<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h2 class="mat-headline-middle">Forgot password</h2>
      <h3 class="mat-h3 text-center">
        Here you can reset your password. Enter your E-mail address and you will
        recieve an E-mail with the instructions to reset your password.
      </h3>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-sm-12 col-md-6">
      <form [formGroup]="forgotPasswordForm" class="d-flex flex-column">
        <mat-form-field appearance="outline">
          <mat-label>E-Mail</mat-label>
          <input matInput type="email" formControlName="email" />
          <mat-error *ngIf="emailFieldHasError"
            >This E-Mail address is not valid!</mat-error
          >
        </mat-form-field>
        <div id="reCaptchaDiv" class="d-flex justify-content-center"></div>
        <div class="mt-3 d-flex flex-row justify-content-center">
          <button
            mat-raised-button
            type="submit"
            color="accent"
            [disabled]="emailFieldHasError"
            (click)="resetPassword(forgotPasswordForm.value)"
          >
            Reset password
          </button>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="sendingSuccessful" class="row">
    <div class="col-md-12 d-flex flex-column align-items-center pt-5">
      <mat-icon class="successIcon mb-3">check_circle</mat-icon>
      <h2 class="mat-h2">The reset E-mail has been sent!</h2>
    </div>
  </div>
</div>
